import { WatermarkListItem, type MaterialListItem } from '@/services/material/index.d';

export const Tracker = {
    /**
     * 打开表格子面板
     */
    openTablePanel() {
        window._stat_track('tpbj_subfunction_click', {
            func: '28_111',
        });
    },

    /**
     * 打开二维码子面板
     */
    openQrCodePanel() {
        window._stat_track('tpbj_subfunction_click', {
            func: '28_112',
        });
    },

    /**
     * 打开素材面板 - 图片
     */
    openMaterialPictureCollapse(recordId?: number) {
        window._stat_track('tpbj_subfunction_click', {
            func: '28_172',
            open: true,
            record_id: recordId,
        });
    },

    /**
     * 打开素材面板 - 背景
     */
    openMaterialBackgroundCollapse(recordId?: number) {
        window._stat_track('tpbj_subfunction_click', {
            func: '28_173',
            open: true,
            record_id: recordId,
        });
    },

    /**
     * 打开文字素材面板
     */
    openTextMaterialCollapse(recordId?: number) {
        window._stat_track('tpbj_subfunction_click', {
            func: '12',
            open: true,
            record_id: recordId,
        });
    },

    /**
     * 打开画笔素材面板
     */
    openBrushMaterialCollapse(recordId?: number) {
        window._stat_track('tpbj_subfunction_click', {
            func: '25',
            open: true,
            record_id: recordId,
        });
    },

    /**
     * 通过画笔预设添加图层
     */
    addBrushOrVectorLayerByPreset() {
        window._stat_track('tpbj_subfunction_click', {
            func: '28_109',
        });
        window._stat_track('tpbj_subfunction_tick', {
            func: '28_109',
        });
    },

    /**
     * 开始使用标注笔
     * @param recordId - 记录 ID
     */
    startUsingMarkup(recordId?: string) {
        window._stat_track('tpbj_subfunction_click', {
            func: '28_160',
            record_id: `${recordId}`,
            click_type: 1,
        });
    },

    /**
     * 绘制结束
     */
    drawEnd(recordId?: string) {
        window._stat_track('tpbj_subfunction_tick', {
            func: '28_160',
            record_id: recordId,
        });
    },

    /**
     * 选择二维码样式
     */
    selectQrCodeStyle() {
        window._stat_track('tpbj_subfunction_click', {
            func: '28_112',
        });
    },

    /**
     * 根据预设数据添加表格图层
     */
    addTableLayerByPreset(presetID: string, recordId: string) {
        window._stat_track('hb_text_edit_yes_data', {
            form_style: presetID,
        });
        window._stat_track('tpbj_subfunction_tick', {
            func: '28_111',
            record_id: recordId,
        });
    },

    /**
     * 导入 Excel
     */
    importExcel() {
        window._stat_track('tpbj_subfunction_click', {
            func: '24_106',
        });
    },

    /**
     * 根据 Excel 数据添加表格图层
     */
    addTableLayerByExcel() {
        window._stat_track('tpbj_subfunction_tick', {
            func: '24_106',
        });
    },

    /**
     * 根据预设数据添加文本图层
     */
    addTextLayerByPreset() {
        window._stat_track('tpbj_subfunction_click', {
            func: '28_50',
        });
        window._stat_track('tpbj_subfunction_tick', {
            func: '28_50',
        });
    },

    /**
     * 根据预设数据添加图片图层
     */
    addImageLayerByPreset() {
        window._stat_track('tpbj_subfunction_click', {
            func: '28_107',
        });
        return () => {
            window._stat_track('tpbj_subfunction_tick', {
                func: '28_107',
            });
        };
    },

    /**
     * 打开图片素材弹窗
     */
    openImageModal() {
        window._stat_track('tpbj_subfunction_click', {
            func: '28_107',
        });
    },

    /**
     * 上传图片成功
     */
    uploadImageSuccess() {
        window._stat_track('tpbj_subfunction_tick', {
            func: '28_107',
        });
    },

    /**
     * 素材曝光埋点
     * @param data - 素材数据
     */
    materialExpose(data: MaterialListItem) {
        const formatType = (() => {
            const stickType = data['stick_type'];
            return stickType === 1 ? '2' : '1';
        })();

        window._stat_track('tpbj_material_show', {
            func: 'sc',
            material_id: data.id,
            label_id: '',
            type_id: data['type_id'],
            belong: 0,
            is_search: 0,
            local_ind: 0,
            material_vip: data.threshold,
            format_type: formatType,
        });
    },

    /**
     * 水印曝光埋点
     * @param data - 水印素材数据
     */
    watermarkExpose(data: WatermarkListItem) {
        window._stat_track('tpbj_watermark_show', {
            func: 'sy',
            material_id: data.id,
            label_id: '',
            type_id: data['type_id'],
            belong: 0,
            manage_type: 0,
            is_search: 0,
            material_vip: data.threshold,
            local_ind: 0,
        });
    },
};
